import { useDispatch } from 'react-redux';
import { addOpenEventsMasterList, openEvents, setLastRefreshed } from '../store/feature/OpenEventsListSlice';
import { getOpenEvents } from '../services/otsEventService';
import { FilterOpenEvents, SortOtsCards, setDragAndDropOrder } from '../components/Sort/SortOtsCards';
import { useAuthentication } from 'meportal/AuthenticationProvider';

export const useOpenEvents = (viewEventTypes: any, eventTypeFilters: any, defaultSort: string, dragAndDropEventList: any) => {
  const dispatch = useDispatch();
  const { userData, getLatestAccessToken } = useAuthentication();

  const getOpenEventsFromSource = async () => {
    let isoDateString = new Date().toISOString();
    
    try {
      const token = await getLatestAccessToken();
      userData.access_token = token;
      const data = await getOpenEvents(userData, "");
      
      if (data == null) {
        return;
      }
      
      dispatch(addOpenEventsMasterList(data));
      let filteredEvents = FilterOpenEvents(eventTypeFilters, data);
      let viewable = filteredEvents.filter((aircraft: any) => 
        viewEventTypes.some((viewableEventType: any) => viewableEventType.Name === aircraft.EventType)
      );
      
      let list = SortOtsCards(
        eventTypeFilters, 
        viewable, 
        defaultSort.split('-')[0], 
        parseInt(defaultSort.split('-')[1])
      );
      
      if (dragAndDropEventList.length > 0) {
        list = setDragAndDropOrder(list, viewEventTypes, dragAndDropEventList);
      }
      
      dispatch(setLastRefreshed(isoDateString));
      dispatch(openEvents(list));
    } catch (error) {
      console.error("Error fetching open events:", error);
    }
  };

  return { getOpenEventsFromSource };
};